import React from 'react';
import PropTypes from 'prop-types';
import {
  MobileExplanationsWithMenu,
  MobileExplanations,
} from '../../../FinancialPlan/Explanations/ExplanationsContainer';
import { createCustomPropType, isNumeric, isUuid } from '../../../../js/app/react/validators';
import { MobileActionStepsV2 } from '../../../FinancialPlan/ActionStepsV2/ActionStepsV2Container';
import { MobileProgressChart } from '../../../FinancialPlan/Insurance/Life/ProgressChart/ProgressChartContainer';
import {
  NEEDS_ANALYSIS,
  INCOME_REPLACEMENT,
} from '../../../FinancialPlan/Insurance/Life/ProgressChart/ProgressChartConstants';
import MobileTopNavWithButtonsSmall from '../../../MobileTopNav/MobileTopNavWithButtonsSmallView';
import MobileTopNavSmallView from '../../../MobileTopNav/MobileTopNavSmallView';

const MobileLifeView = ({
  clientId,
  fpId,
  goalId,
  subgoalId,
  note,
  setSelectedOwnerIndex,
  selectedOwnerIndex,
  subgoalData,
}) => (
  <div className="NewFinancialPlan_Insurance_Life">
    {subgoalData.SpouseName ? (
      <MobileTopNavWithButtonsSmall
        onClick={() => window.history.back()}
        headerText="Insurance"
        selectedIndex={selectedOwnerIndex}
        onButtonsClick={[
          setSelectedOwnerIndex(clientId, goalId)(0),
          setSelectedOwnerIndex(clientId, goalId)(1),
        ]}
        buttonsTexts={[subgoalData.PrincipalName, subgoalData.SpouseName]}
      />
    ) : (
      <MobileTopNavSmallView onClick={() => window.history.back()} headerText="Insurance" />
    )}
    <MobileExplanationsWithMenu clientId={clientId} />
    <div className="mobile-content-scrollable-small-topnav-gray">
      <MobileExplanations clientId={clientId} />
      <section className="chart mobile no-padding-bottom less-padding-left less-padding-right">
        <MobileProgressChart
          tabs={[NEEDS_ANALYSIS, INCOME_REPLACEMENT]}
          clientId={clientId}
          goalId={goalId}
          fpId={fpId}
          subgoalId={subgoalId}
          subgoalData={subgoalData}
          note={note}
          principalName={subgoalData.PrincipalName}
          spouseName={subgoalData.SpouseName}
          setSelectedOwnerIndex={setSelectedOwnerIndex(clientId, goalId)}
        />
      </section>
      <MobileActionStepsV2 clientId={clientId} fpId={fpId} />
    </div>
  </div>
);
MobileLifeView.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  subgoalId: PropTypes.string.isRequired,
  note: PropTypes.shape({}).isRequired,
  setSelectedOwnerIndex: PropTypes.func.isRequired,
  subgoalData: PropTypes.shape({}).isRequired,
  selectedOwnerIndex: PropTypes.number.isRequired,
};

export default MobileLifeView;
